module.exports = __webpack_public_path__ + "img/PDF-icon.a0a693ed.png";